import React,  { useState, useEffect } from 'react';
import CustomCheckbox                  from '../../input-elements/checkbox';
import CustomRadiobox                  from '../../input-elements/radiobox';
import { useTranslation }              from 'react-i18next';

interface FilterOverlayProps {
    open: boolean;
    handleClick?: () => void;
    handleFilterChange: (filter: { [key: string]: boolean; }) => void;
}

type CheckStates = {
    [key: string]: boolean;
};

const FilterOverlay: React.FC<FilterOverlayProps> = ({ open, handleClick, handleFilterChange}) => {
    const { t } = useTranslation();

    const [checkedStates, setCheckedStates] = useState<{ [filter: string]: boolean }>({
        digital: true,
        life: true,
        manufacturing: true,
        energy: true
    });

    const [selected, setSelected] = useState('all');

    useEffect(() => {
        handleFilterChange(checkedStates);
    }, [checkedStates]);

    useEffect(() => {
        const handleRadioSelection = (selectedValue: string) => {
            switch(selectedValue) {
                case 'all':
                    setCheckedStates(prevState => setAllStatesToValue(prevState, true));


                    break;
                case 'select':
                    setCheckedStates(prevState => setAllStatesToValue(prevState, false));

                    break;
                default:
                    return null;
            }
        };

        handleRadioSelection(selected);
    }, [selected]); // Only re-run the effect if selected changes

    const setAllStatesToValue = (prevState: CheckStates, value: boolean): CheckStates  => {
        const newState = { ...prevState };
        Object.keys(newState).forEach(key => {
            newState[key] = value;
        });
        return newState;
    }

    const handleCheckboxChange = (filter: string) => (checked: boolean) => {
        setCheckedStates({
            ...checkedStates,
            [filter]: checked,
        });

        handleFilterChange(checkedStates);
    }

    const resetFilter = () => {
        setCheckedStates(prevState => {
            let newState = {...prevState};

            for(let key in newState) {
                newState[key] = true;
            }

            return newState;
        });
    }

    return (
        <div className={`filter-overlay ${open ? 'open' : ''}`}>
            <button
                className="close-button"
                onClick={handleClick}
                role="button"
                tabIndex={0}
                aria-disabled={false}
            >
            </button>
            <div className='filter-content'>
                <div className='filter-overlay-title'>{t('researchArea')}</div>

                <div className={'filters'}>
                    <div className={'filter-select'}>
                        <CustomRadiobox
                            checked={selected === 'all'}
                            label="Alle Bereiche"
                            onCheckedChange={() => setSelected('all')}
                        />

                        <CustomRadiobox
                            checked={selected === 'select'}
                            label="Bereiche auswählen"
                            onCheckedChange={() => setSelected('select')}
                        />
                    </div>

                    <CustomCheckbox
                        class="digital"
                        checked={checkedStates.digital}
                        label="Digitale Welt"
                        onCheckedChange={handleCheckboxChange('digital')}
                    />

                    <CustomCheckbox
                        class={"energy"}
                        checked={checkedStates.energy}
                        label="Energie und Umwelt"
                        onCheckedChange={handleCheckboxChange('energy')}
                    />

                    <CustomCheckbox
                        class={"manufacturing"}
                        checked={checkedStates.manufacturing}
                        label="Fertigungsprozesse und Materialien"
                        onCheckedChange={handleCheckboxChange('manufacturing')}
                    />

                    <CustomCheckbox
                        class={"life"}
                        checked={checkedStates.life}
                        label="Life Sciences"
                        onCheckedChange={handleCheckboxChange('life')}
                    />
                </div>

                <div className='filter-reset' onClick={resetFilter}>{t('Filter zurücksetzen')}</div>

                <button onClick={handleClick} className={'show-results-button'}>{t('Ergebnisse anzeigen')}</button>

            </div>
        </div>
    );
}

export default FilterOverlay;